import { FailedRequest } from '@ideals/core/sentry';

import { HttpError, RequestError } from '../../models';

type NormalizedErrorContract =
  & Pick<HttpError, 'headers' | 'method' | 'status' | 'statusCode' | 'traceparent' | 'url'>
  & Pick<RequestError, 'errorCode' | 'headers' | 'method' | 'status' | 'statusCode' | 'traceparent' | 'url'>;

type NormalizedError = Partial<Record<keyof NormalizedErrorContract, unknown>>;

const HTTP_METHODS = new Set<string>(['DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT']);

export function toFailedRequest(value: unknown): FailedRequest | undefined {
  if (value == null || typeof value !== 'object' || value instanceof Error) {
    return undefined;
  }

  const { errorCode, headers, method, status, statusCode, traceparent, url } = value as NormalizedError;
  const isTraced = typeof traceparent === 'string' || typeof errorCode === 'number';
  const isNormalized = isTraced
    && typeof headers === 'object' && headers != null
    && typeof method === 'string' && HTTP_METHODS.has(method)
    && typeof status === 'string' && status !== ''
    && typeof statusCode === 'number'
    && (typeof url === 'string' || url == null);

  if (!isNormalized) {
    return undefined;
  }

  return {
    errorCode: typeof errorCode === 'number' ? errorCode : undefined,
    method,
    status,
    statusCode,
    url: url ?? null,
  };
}
